import { render, staticRenderFns } from "./InformationPage.vue?vue&type=template&id=deb1bcfe&scoped=true"
import script from "./InformationPage.vue?vue&type=script&lang=js"
export * from "./InformationPage.vue?vue&type=script&lang=js"
import style0 from "./InformationPage.vue?vue&type=style&index=0&id=deb1bcfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb1bcfe",
  null
  
)

export default component.exports